import request from '@api';

export const getRASettings = async () => {
  try {
    // https://www.notion.so/wassupkover/op-onboarding-api-doc-df765a50bad24b5fa7ddba72a42a1c4a#8b6253e68d9c4a00bc2e207cb9c13181
    const resp = await request('get-merchant-ra-settings');
    // const {code, data} = MOCK_DATA;
    // const {widgetVO: {defaultOn} = { } } = data;
    return resp;
  } catch (e) {
    console.log(e);
  }
  return {};
};

export const getBPSettings = async () => {
  try {
    const resp = await request('get-merchant-bp-settings');
    // const {code, data} = MOCK_DATA;
    // const {widgetVO: {defaultOn} = { } } = data;
    return resp;
  } catch (e) {
    console.log(e);
  }
  return {};
};
